module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Wallet-b2209b7b22002dd6a3a1ebd30ffaa785.svg";